"use strict";
// The Capablity KEYS!
const KBGP = 'kbgp';
const KDNS = 'kdns';
const KPROXY = 'kproxy'; // still behind a perm
const KSNMPTRAP = 'ksnmptrap'; // only behind a perm
const KSYSLOG = 'ksyslog'; // only behind a perm
const RANGER = 'ranger';
// Block from public!
const LIVESYNTH = 'livesynth';
const KPACKET = 'kpacket';
// NOT YET but planned
const KSYNTH = 'ksynth';
const KDUMMY = 'kdummy';
const SUDO_ONLY_FANOUT_COUNT_OPTIONS = [1, 2, 4, 8, 16, 32, 64];
const CAPABILITIES_DEFAULT_CONFIGS = {
    [KDNS]: {
        args: {
            interface: 'any',
            fanoutCount: '4',
            enableCompression: true,
            promiscuous: false,
            sampleRate: 1
        }
    },
    [KPROXY]: {
        args: {
            host: '0.0.0.0',
            port: 9995,
            basePort: 40010,
            sflowAgentAddress: false,
            logLevel: 'info'
        }
    },
    [KSNMPTRAP]: {
        args: {}
    },
    [KSYSLOG]: {
        args: {}
    }
};
const KDNS_DEFAULTS = CAPABILITIES_DEFAULT_CONFIGS[KDNS].args;
const kdnsConfigArguments = {
    interface: {
        argument: '-interface',
        userControlled: true,
        type: 'select',
        showInputFilter: true,
        label: 'Interface',
        cannotDelete: true,
        default: KDNS_DEFAULTS.interface,
        // default said eth0 before - Alistair says "eth0 would be bad."
        description: 'Interface to listen for flow on (default "All")'
    },
    fanoutCount: {
        argument: '--fan-count',
        sudoRequired: true,
        userControlled: true,
        type: 'select',
        label: 'Fanout Count',
        default: KDNS_DEFAULTS.fanoutCount,
        options: SUDO_ONLY_FANOUT_COUNT_OPTIONS.map((i) => ({ label: i, value: i }))
    },
    enableCompression: {
        argument: '--enable-compression',
        label: 'Enable Compression',
        sudoRequired: true,
        userControlled: true,
        default: KDNS_DEFAULTS.enableCompression,
        type: 'bool'
    },
    promiscuous: {
        argument: '--promiscuous',
        label: 'Promiscuous Mode',
        default: KDNS_DEFAULTS.promiscuous,
        description: 'Enable promiscuous mode',
        showTrueFalse: true,
        cannotDelete: true,
        userControlled: true,
        type: 'select',
        rules: ['required', 'boolean'],
        options: [
            { label: 'On', value: true },
            { label: 'Off', value: false }
        ]
    },
    sampleRate: {
        argument: '--sample-rate',
        label: 'Sample Rate',
        sudoRequired: true,
        userControlled: true,
        rules: ['numeric'],
        default: KDNS_DEFAULTS.sampleRate,
        type: 'select'
    }
};
const KRPOXY_DEFAULTS = CAPABILITIES_DEFAULT_CONFIGS[KPROXY].args;
const kproxyConfigArgumentsDictionary = {
    activeListen: {
        argument: '-active_listen',
        type: 'string',
        description: 'Run Active measurement server on this host:port combo (0.0.0.0:8080)'
    },
    activeMaxSpeed: {
        argument: '-active_max_speed',
        type: 'float',
        description: 'Cap active measurement at this rate (bytes/sec). 0 is uncapped.'
    },
    activeProtocol: {
        argument: '-active_protocol',
        type: 'string',
        description: 'Active measurement protocol. (udp|tcp|icmp) (default "tcp")'
    },
    activeServers: {
        argument: '-active_servers',
        type: 'string',
        description: 'Active measurement servers to connect to. Host and port, comma separated. (127.0.0.1:8080,127.0.02:8080)'
    },
    alertFwd: {
        argument: '-alert_fwd',
        type: 'string',
        description: 'Location to send a copy of flow to for v3 alerting'
    },
    api: {
        argument: '-api',
        type: 'string',
        description: 'API to use (default "https://api.kentik.com/api/internal")'
    },
    apiEmail: {
        argument: '-api_email',
        blockInUI: true,
        type: 'string',
        description: 'Email to use when connecting to the CH API'
    },
    apiPass: {
        argument: '-api_pass',
        blockInUI: true,
        type: 'string',
        description: 'Password to use when connecting to the CH API'
    },
    apiToken: {
        argument: '-api_token',
        type: 'string',
        description: 'Password to use when connecting to the CH API'
    },
    basePort: {
        argument: '-base_port',
        userControlled: true,
        type: 'int',
        default: KRPOXY_DEFAULTS.basePort,
        rules: ['integer', 'min:0', 'max:65535'],
        label: 'Base Port',
        description: 'Port to begin sending flow to as more devices export flow (default 40010)'
    },
    bgpNeighborAsn: {
        argument: '-bgp_neighbor_asn',
        type: 'int',
        description: '[deprecated] ASN of BGP neighbor'
    },
    bgpNeighborIp: {
        argument: '-bgp_neighbor_ip',
        type: 'string',
        description: 'IP of IPv4 BGP neighbor',
        rules: ['required', 'ipNoCidr']
    },
    bgpNeighborIp6: {
        argument: '-bgp_neighbor_ip6',
        type: 'string',
        description: 'IP of IPv6 BGP neighbor',
        rules: ['v6IpCidr']
    },
    bgpProxy: {
        argument: '-bgp_proxy',
        type: 'string',
        description: '[deprecated] BGP proxy IP:PORT'
    },
    bgpProxy6: {
        argument: '-bgp_proxy6',
        type: 'string',
        description: '[deprecated] BGP proxy IP:PORT'
    },
    bgpConfigFile: {
        argument: '-bgp_config_file',
        type: 'string',
        description: 'BGPd JSON configuration file'
    },
    bootstrapDevices: {
        argument: '-bootstrap_devices',
        type: 'string',
        description: 'Spin up a pre-sent client for these devices. Comma separated list of device ids (12002,1221)'
    },
    clientId: {
        argument: '-client_id',
        type: 'string',
        description: 'Client ID (company_id:device_name:device_id) (default "100:default:110")'
    },
    cloudMap: {
        argument: '-cloud_map',
        type: 'string',
        description: 'File to use for mapping cloud ranges'
    },
    customCols: {
        argument: '-custom_cols',
        type: 'string',
        description: 'Map of custom column names to ids for this device'
    },
    deviceStat: {
        argument: '-device_stat',
        type: 'string',
        description: 'Obsolete'
    },
    deviceStatSslUrl: {
        argument: '-device_stat_ssl_url',
        type: 'string',
        description: 'Obsolete'
    },
    deviceSubtype: {
        argument: '-device_subtype',
        type: 'string',
        description: 'Client Device Subtype'
    },
    deviceType: {
        argument: '-device_type',
        type: 'string',
        description: 'Client Device Type'
    },
    // Keep this as there was some ambiguity
    dnsResolv: {
        argument: '-dns_resolv',
        // userControlled: true,
        type: 'string',
        rules: ['ipv4Port'],
        // description: 'DNS Resolv file location (default "/etc/resolv.conf")',
        label: 'rDNS flow enrichment',
        placeholder: '<DNS_Server_IPv4>:<DNS_Server_UDP_Port>'
    },
    dns: {
        argument: '-dns',
        label: 'rDNS flow enrichment',
        userControlled: true,
        type: 'string',
        rules: ['ipv4Port'],
        placeholder: '<DNS_Server_IPv4>:<DNS_Server_UDP_Port>',
        description: 'Try to resolve flow addresses against this host:port (UDP only)'
    },
    dnstagd: {
        argument: '-dnstagd',
        type: 'string',
        description: 'If set, the address:port to contact for a dnstag assignment'
    },
    dump: {
        argument: '-dump',
        type: 'int',
        description: 'Dump Every MS (default 1000)'
    },
    exitLowTraffic: {
        argument: '-exit_low_traffic',
        type: 'bool',
        description: 'Exit if traffic is 0 for 15 min'
    },
    extensibleCols: {
        argument: '-extensible_cols',
        type: 'string',
        description: 'Map of extensible column names to ids for this device'
    },
    fg: {
        argument: '-fg',
        type: 'bool',
        description: 'Run in foreground, not using a guarding process.'
    },
    forceBgp: {
        argument: '-force_bgp',
        type: 'bool',
        description: 'Obsolete'
    },
    forkedPprofHost: {
        argument: '-forked_pprof_host',
        type: 'string',
        description: 'Bind PPROF for forked clients to this interface and the healthcheck port (optional)'
    },
    geo: {
        argument: '-geo',
        type: 'string',
        description: 'GEO File Location (default "/usr/share/cloudhelix/country.csv")'
    },
    geoSmall: {
        argument: '-geo_small',
        type: 'bool',
        description: 'Use small geo file'
    },
    healthcheck: {
        argument: '-healthcheck',
        type: 'string',
        description: 'Bind to this interface to allow healthchecks (127.0.0.1) (default "127.0.0.1")'
    },
    host: {
        argument: '-host',
        label: 'Host',
        userControlled: true,
        cannotDelete: true,
        rules: ['ipv4'],
        type: 'string',
        default: KRPOXY_DEFAULTS.host,
        description: 'Host to listen for flow on (default "0.0.0.0")'
    },
    hostname: {
        argument: '-hostname',
        type: 'string',
        description: 'Obsolete'
    },
    http: {
        argument: '-http',
        type: 'string',
        description: 'HTTP port to bind on (default "off")'
    },
    httpUdr: {
        argument: '-http_udr',
        type: 'string',
        description: 'Run an HTTP server here, listening for UDR metrics passed in. Write these into flow and send along.'
    },
    interfaceMetadataComparison: {
        argument: '-interface_metadata_comparison',
        type: 'string',
        description: 'Interface metadata comparison type'
    },
    justActive: {
        argument: '-just_active',
        type: 'bool',
        description: 'Only perform active measurements'
    },
    leaderId: {
        argument: '-leader_id',
        type: 'string',
        description: 'Leader ID (company_id:device_name:device_id) for sdmi'
    },
    listen: {
        argument: '-listen',
        label: 'Listen',
        type: 'string',
        description: 'Obsolete'
    },
    localProxy: {
        argument: '-local_proxy',
        type: 'string',
        description: 'Route HTTP via this proxy, e.g. “http://proxy:3128”'
    },
    logLevel: {
        argument: '-log_level',
        userControlled: true,
        sudoRequired: true,
        type: 'select',
        options: [
            { value: 'debug', label: 'Debug' },
            { value: 'info', label: 'Info' },
            { value: 'warn', label: 'Warn' },
            { value: 'error', label: 'Error' },
            { value: 'panic', label: 'Panic' },
            { value: 'disabled', label: 'Disabled' }
        ],
        default: KRPOXY_DEFAULTS.log_level,
        autoShowValue: 'info',
        label: 'Log Level',
        description: 'Logging Level: access|debug|info|warn|error|panic|off (default "info")'
    },
    logstash: {
        argument: '-logstash',
        type: 'string',
        description: 'logstash endpoint (kproxy only), ‘DISABLE’ to disable'
    },
    maskFile: {
        argument: '-mask_file',
        type: 'string',
        description: 'Truncates results of IP matches to the corresponding subnet based on netmask in CIDR format. List must contain netmask for v4,v6 and may ' +
            'contain CIDR blocks that are outside of default mask. Format is: first line: v4,v6 cidrs, After list of cidrs'
    },
    max: {
        argument: '-max',
        type: 'int',
        description: 'Max FPS (default 4000)'
    },
    maxBig: {
        argument: '-max_big',
        type: 'int',
        description: 'Max Big FPS (default 30)'
    },
    maxHttpSend: {
        argument: '-max_http_send',
        type: 'int',
        description: 'Number of outstanding HTTP connections (default 10)'
    },
    metrics: {
        argument: '-metrics',
        type: 'string',
        description: 'Metrics Configuration. none|syslog|stderr|graphite:127.0.0.1:2003'
    },
    myNetwork: {
        argument: '-my_network',
        label: 'My Network',
        autoShowValue: '',
        // do not use UserControlled here - this is a special case - my_network cannot exist without dns
        dependsOn: ['dns'],
        rules: ['commaSeparatedIPsCIDRwithNetclass'],
        type: 'string',
        description: 'Comma separated list of cidrs to treat as internal (10.10.0.0/16,23.1.3.0/24)'
    },
    numHttpSend: {
        argument: '-num_http_send',
        type: 'int',
        description: 'Number of HTTP sending threads (default 5)'
    },
    pcapFlowPeriod: {
        argument: '-pcap_flow_period',
        type: 'int',
        description: 'Obsolete'
    },
    pcapTransmitPeriod: {
        argument: '-pcap_transmit_period',
        type: 'int',
        description: 'Obsolete'
    },
    port: {
        argument: '-port',
        userControlled: true,
        cannotDelete: true,
        default: KRPOXY_DEFAULTS.port,
        type: 'int',
        description: 'Port to listen for flow on (default 9995)',
        rules: ['required', 'integer', 'min:0', 'max:65535'],
        label: 'Port',
        placeholder: 'UDP [1024-49151] port'
    },
    proxyHttp: {
        argument: '-proxy-http',
        type: 'string',
        description: 'Set up forward HTTP proxy at the port',
        label: 'Proxy HTTP'
    },
    proxyHttpAllow: {
        argument: '-proxy-http-allow',
        type: 'string',
        description: 'If running a forward proxy, a single domain to which proxying should be allowed (default “.kentik.com”)'
    },
    proxyHost: {
        argument: '-proxy_host',
        type: 'string',
        description: 'Interface to use for proxied clients. Defaults to -host value if not set'
    },
    proxyPcap: {
        argument: '-proxy_pcap',
        type: 'bool',
        description: 'Obsolete'
    },
    proxySnmp: {
        argument: '-proxy_snmp',
        type: 'string',
        description: 'Interface to use for proxied clients on SNMP polling. Defaults to -host value if not set'
    },
    rateLimit: {
        argument: '-rateLimit',
        type: 'uint',
        description: 'Obsolete (default 12000)'
    },
    rcvbufSize: {
        argument: '-rcvbuf_size',
        type: 'int',
        description: 'number of bytes to give to the main UDP rcv buffer if in proxy mode'
    },
    realtime: {
        argument: '-realtime',
        type: 'bool',
        description: 'Obsolete (default true)'
    },
    region: {
        argument: '-region',
        blockInUI: true,
        type: 'string',
        description: 'Way to set common flags for a given region'
    },
    remapFile: {
        argument: '-remap_file',
        type: 'string',
        description: 'File to use to remap IPs while in agent mode'
    },
    rpkiBind: {
        argument: '-rpki_bind',
        type: 'string',
        description: 'Run RPKI server at this address (default off)'
    },
    rpkiCache: {
        argument: '-rpki_cache',
        type: 'string',
        description: 'URL of the cached RPKI JSON data (default off)'
    },
    rpkiLocalCache: {
        argument: '-rpki_local_cache',
        type: 'string',
        description: 'Local place to cache rpki data (default "/data/blob-storage/rpki/local.cache")'
    },
    sampleInterval: {
        argument: '-sampleInterval',
        type: 'int',
        description: 'Number of milliseconds across which any flow downsampling should occur, when running in proxy mode (default 15000)'
    },
    sampleMetric: {
        argument: '-sample_metric',
        type: 'int',
        description: 'Sample Rate to use for metrics like SNMP counters (default 1)'
    },
    sampleRate: {
        argument: '-sample_rate',
        type: 'int',
        description: "Sample rate - default of 0 means we'll get it from the server"
    },
    servers: {
        argument: '-servers',
        type: 'string',
        description: 'Comma separated list of CHF Servers to talk to (default "tcp://127.0.0.1:9996")'
    },
    sflowAgentAddress: {
        argument: '-sflow_agent_address',
        label: 'Sflow Agent Address', // ALT: use the agent address for sending ip
        userControlled: true,
        default: KRPOXY_DEFAULTS.sflowAgentAddress,
        type: 'bool',
        description: 'If set, use the agent address for sending ip (kproxy only)'
    },
    sflowDropEgress: {
        argument: '-sflow_drop_egress',
        type: 'bool',
        description: 'If an sflow device, drop packet-samples that we know to be egress packets (datasource == dst-interface)'
    },
    shardNum: {
        argument: '-shard_num',
        type: 'int',
        description: 'For a sharded device, what shard am I'
    },
    siteId: {
        argument: '-site_id',
        label: 'Site', // 'Site ID',
        userControlled: true,
        type: 'siteSelect',
        description: 'ID of Kentik site to look devices up in'
    },
    sleep: {
        argument: '-sleep',
        type: 'int',
        description: 'Sleep this long (MS) before proceeding to init Client'
    },
    snmp: {
        argument: '-snmp',
        type: 'string',
        description: 'Obsolete'
    },
    snmpCommunity: {
        argument: '-snmp_community',
        type: 'string',
        description: 'SNMP community'
    },
    snmpFile: {
        argument: '-snmp_file',
        type: 'string',
        description: 'File to use to look up SNMP data while in agent mode'
    },
    snmpIp: {
        argument: '-snmp_ip',
        type: 'string',
        description: 'IP Address to poll for SNMP data'
    },
    snmpLow: {
        argument: '-snmp_low',
        type: 'bool',
        description: 'Poll for SNMP at a low rate. Turn off SNMP counter polling.'
    },
    snmpMax: {
        argument: '-snmp_max',
        type: 'int',
        description: 'Number of device interfaces we import from SNMP, sorted by traffic (default 750)'
    },
    snmpMaxCycle: {
        argument: '-snmp_max_cycle',
        type: 'int',
        description: 'Number of device interfaces we import from SNMP, sorted by traffic, after initial run (default 500)'
    },
    snmpMaxRepetitions: {
        argument: '-snmp_max_repetitions',
        type: 'int',
        description: 'The max repetitions for snmp polling (default 50)'
    },
    snmpRetries: {
        argument: '-snmp_retries',
        type: 'int',
        description: 'The retries setting for snmp polling'
    },
    snmpTimeoutSeconds: {
        argument: '-snmp_timeout_seconds',
        type: 'int',
        description: 'The timeout seconds settings for snmp polling (default 5)'
    },
    snmpV3: {
        argument: '-snmp_v3',
        type: 'string',
        description: 'SNMP V3 Info'
    },
    sqlProxyListen: {
        argument: '-sql_proxy_listen',
        type: 'string',
        description: 'Bind sql proxy for client on this host:port (default "127.0.0.1:20017")'
    },
    stDialoutListener: {
        argument: '-st_dialout_listener',
        type: 'string',
        description: 'Process dialout ST. Supported types: junos|ios|auto'
    },
    stTcpBind: {
        argument: '-st_tcp_bind',
        type: 'string',
        description: 'Run TCP ST dialout server at this address (default off)'
    },
    stUdpBind: {
        argument: '-st_udp_bind',
        type: 'string',
        description: 'Run UDP ST dialout server at this address (default off)'
    },
    stV1: {
        argument: '-st_v1',
        type: 'string',
        description: 'STv1 info (JSON)'
    },
    stdout: {
        argument: '-stdout',
        type: 'bool',
        description: 'Log using stdout'
    },
    syslog: {
        argument: '-syslog',
        type: 'bool',
        description: 'Log using syslog'
    },
    syslogConf: {
        argument: '-syslog_conf',
        type: 'string',
        description: 'Path to file describing syslog settings'
    },
    tagUpdate: {
        argument: '-tag_update',
        type: 'int',
        description: 'Obsolete (default 1200)'
    },
    tagUrl: {
        argument: '-tag_url',
        type: 'string',
        description: 'URL to pull tags from (default "https://api.kentik.com/api/internal/company/COMPANY_ID/device/DEVICE_ID/tags")'
    },
    teeKproxy: {
        argument: '-tee_kproxy',
        type: 'string',
        description: 'If set, tee traffic to this location in the kproxy case. Format is (<src-ip>:)<dst-ip>:<dst-port>'
    },
    testSnmp: {
        argument: '-test_snmp',
        type: 'bool',
        description: 'Run using the passed in config to check SNMP and then exit.'
    },
    tlsCaFile: {
        argument: '-tls_ca_file',
        type: 'string',
        description: 'x509 CA file to use'
    },
    tlsCertFile: {
        argument: '-tls_cert_file',
        type: 'string',
        description: 'x509 cert file to use'
    },
    tlsKeyFile: {
        argument: '-tls_key_file',
        type: 'string',
        description: 'x509 cert key file to use'
    },
    totalShards: {
        argument: '-total_shards',
        type: 'int',
        description: 'For a sharded device, total number of shards'
    },
    type: {
        argument: '-type',
        type: 'string',
        description: 'Client Type: sflow|ipfix|v5|v9|proxy|kflow|snmp_check (default "proxy")'
    },
    updateOnRestart: {
        argument: '-update_on_restart',
        type: 'bool',
        description: 'Update the code when starting.'
    },
    useAsnFromFlow: {
        argument: '-use_asn_from_flow',
        type: 'bool',
        description: 'If set, use asn from flow instead of clearing to default asn'
    },
    useUeFromFlow: {
        argument: '-use_ue_from_flow',
        type: 'bool',
        description: 'If set, use ue from flow instead of doing UE enrichment'
    },
    v: {
        argument: '-v',
        type: 'bool',
        description: 'Version'
    },
    verbose: {
        argument: '-verbose',
        type: 'bool',
        description: 'Obsolete'
    }
};
const CMD_ARGS_KPROXY_KEBAB_OBJ = ['proxyhttp', 'proxyhttpallow'];
const CMD_ARGS_KPROXY_KEBAB = ['-proxy-http', '-proxy-http-allow'];
const CAPABILITY_TITLES = {
    kbgp: 'BGP Proxy (AKA kbgp)',
    kdummy: 'Dummy Capability',
    kdns: 'DNS OTT Tap',
    kproxy: 'Flow Proxy',
    ksnmptrap: 'SNMP Trap Receiver',
    ksynth: 'Synthetics (AKA ksynth)',
    ksyslog: 'Syslog Server',
    livesynth: 'Live Synthetics',
    ranger: 'NMS'
};
const CAPABILITY_DESCRIPTIONS = {
    kbgp: 'Proxy local iBGP Route Reflector Client session from multiple hosts and multiplex them securely to Kentik SaaS cluster',
    kdns: 'Upon installation on a DNS server, collect and export DNS Query Responses to match against Flow Telemetry for OTT detection',
    kproxy: 'Deploy this Agent Capability as an on-prem relay to export Network Flow  Telemetry (Netflow5,9, SFlow, IPFIX) ' +
        'from multiple registered devices to Kentik: point flow exports from your devices to this Agent IP and it will ' +
        'multiplex flow records securely to your KentiK SaaS Cluster.',
    ksnmptrap: 'Receive SNMP Traps and securely transport them to Kentik',
    ksynth: 'Turns host into Kentik Synthetics Agent to perform Network, HTTP and DNS synthetic tests',
    ksyslog: 'Provides syslog server that transports logs to Kentik',
    ranger: 'Base layer of network visibility including up/down, interface stats, and hardware components',
    livesynth: 'Live Synthetics - Run network tests in real-time',
    kdummy: 'Test Capability'
};
const SYNTHETICS = 'Synthetics';
const NOT_AUTHORIZED = 'Not Authorized';
const RUNNING = 'Running';
const DOWN = 'Down';
const DISABLED = 'Disabled';
const WARNING = 'Warning';
const UP = 'Up';
const PENDING = 'Pending';
module.exports = {
    CMD_ARGS_KPROXY_KEBAB,
    CMD_ARGS_KPROXY_KEBAB_OBJ,
    AGENT_HEALTH: {
        AGENT_HEALTH_STATE_HEALTHY: 'AGENT_HEALTH_STATE_HEALTHY',
        AGENT_HEALTH_STATE_UNHEALTHY: 'AGENT_HEALTH_STATE_UNHEALTHY',
        AGENT_HEALTH_STATE_OFFLINE: 'AGENT_HEALTH_STATE_OFFLINE'
    },
    CAPABILITY_TITLES,
    CAPABILITY_DESCRIPTIONS,
    CAPABILITY_HEALTH: {
        CAPABILITY_HEALTH_STATE_HEALTHY: 'CAPABILITY_HEALTH_STATE_HEALTHY',
        CAPABILITY_HEALTH_STATE_UNHEALTHY: 'CAPABILITY_HEALTH_STATE_UNHEALTHY',
        CAPABILITY_HEALTH_STATE_DISABLED: 'CAPABILITY_HEALTH_STATE_DISABLED'
    },
    CAPABILITY_KEYS: {
        KBGP,
        KDNS,
        KDUMMY,
        KPROXY,
        KSNMPTRAP,
        KSYNTH,
        KSYSLOG,
        LIVESYNTH,
        RANGER
    },
    Capabilities: {
        // maybe call Capability_Keys? replacing with above is good
        KBGP,
        KDNS,
        KDUMMY,
        KPROXY,
        KSNMPTRAP,
        KSYNTH,
        KSYSLOG,
        LIVESYNTH,
        RANGER,
        // the guesses
        SYNTHETICS
    },
    Statuses: {
        NOT_AUTHORIZED,
        RUNNING,
        DISABLED,
        DOWN,
        WARNING,
        PENDING,
        UP
    },
    CAPABILITIES_DEFAULT_CONFIGS,
    CAPABILITIES_W_CONFIGS: [KDNS, KPROXY],
    CAPABILITIES_CURRENTLY_AVAILABLE_TO_ALL: [RANGER, KDNS], // KSNMPTRAP, KSYSLOG, and KPROXY are added by permissions
    CAPABILITIES_CURRENTLY_PLANNED: [KSYNTH, KBGP],
    CAPABILITIES_TO_ALWAYS_REMOVE_FROM_PUBLIC: [KPACKET], // UI only setting - do not even show these in the blocked list.
    ALWAYS_SUPPORTED_CAPABILITIES: [RANGER, KSYSLOG, KSNMPTRAP, KDUMMY], // These are distribution-agnostic so can be installed on any linux distribution
    KPROXY_CONFIG_ARGUMENTS: Object.assign({}, kproxyConfigArgumentsDictionary),
    KDNS_CONFIG_ARGUMENTS: Object.assign({}, kdnsConfigArguments)
};
